import React from 'react';
import Button from '../elements/Button';

export default function BrandIcon() {
  return (
    <Button
      className="brand-name"
      type="link"
      href="/"
    >
      <div className="brand-text-container">
        <span className="sysne">SYSNE</span>
        <div className="animated-o-container">
          <ul className="animated-o">
            <li className="first" />
            <li className="second" />
            <li className="third" />
            <li className="fourth" />
            <li className="last" />
          </ul>
        </div>
        <span className="m">M</span>
      </div>
      <div className="line" /> {/* Added line element */}
      <div className="brand-text2 animated-entry">
        <span className="description">Shaping the next generation IT</span>
      </div>
    </Button>
  );
}
